<template lang="pug">
a.link-base(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LinkBase extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.link-base
  text-decoration underline
  outline none

  &:hover
    cursor pointer
</style>
